import React from 'react';
import {RadiusView} from 'src/res/Radius';
import {FontWeightMedium} from 'src/res/FontWeight';
import {logDebug} from "../../utils/AppLog";
import {locString} from "../commons/ViewHelper";
import View from "../commons/View";
import ImageBackground from "../commons/ImageBackground";
import AppImage from "../commons/AppImage";
import CircularProgress from "@material-ui/core/CircularProgress";
import AppUtils, {dispatchSimulationClick} from "../../utils/AppUtils";
import {
  GAME_BOMB_AUDIO,
  GAME_CRUSH_AUDIO,
  GAME_NEUTRAL_AUDIO,
  GAME_TIMER_AUDIO,
  GAME_WIN_AUDIO
} from "../../utils/GameAudioPlayer";
import AppText from "../commons/AppText";
import FocusHelperView from "../commons/FocusHelperView";
import GameAudio from "../commons/GameAudio";
import TouchableOpacityWOFeedback from "../commons/TouchableOpacityWOFeedback";
import AppImageButtonEx from "../commons/AppImageButtonEx";
import {animated, SpringValue} from '@react-spring/web'
import ActivityHelper from "../../utils/ActivityHelper";
import constants from "src/js/constants";

export default class GameWhacAMoleView extends React.PureComponent {

  constructor(props) {
    super(props);
    this.items = this.props.items;
    this.gameLastTime = 0;
    this.endGameProcessStartTime = 0;

    this.state = this.getDefaultState(this.props.value);
  }

  componentDidMount() {
  }

  componentWillUnmount() {
    this.stopGameTimer();
  }

  onDidFocus = () => {
    if (this.wasTimerRunning) {
      this.startGameTimer();
    }
  }

  onDidBlur = () => {
    if (this.intervalHandler) {
      this.wasTimerRunning = true;
      this.stopGameTimer();
    }
  }

  simulatePlay = () => {
    if (this.refStartGame) {
      dispatchSimulationClick(this.refStartGame);
    }
  }

  resetForPreview = (items) => {
    this.reset(items);
  }

  reset = (items, gameValue) => {
    this.stopGameTimer(false);
    setTimeout(() => {
      this.items = items;
      const currentTime = new Date().getTime();
      const idleTime = 2 * 1000;
      const resetAfter = Math.max(0, idleTime - (currentTime - this.endGameProcessStartTime));

      setTimeout(() => {
        this.endGameProcessStartTime = 0;
        this.setState(this.getDefaultState(gameValue ? gameValue.score : 0));
        if (this.refGrid) {
          this.refGrid.reset(this.items);
        }
      }, resetAfter);
    }, 100);
  }

  getDefaultState = (value) => {
    return {
      isGameOver: false,
      isWin: false,
      isLose: false,
      gameTimer: 0,
      movesCount: 0,
      points: value,
    };
  }

  playGamePlayAudio = () => {
    if (this.gamePlayAudioId) {
      this.gamePlayAudioId.play();
    }
  }

  playGameBomAudio = () => {
    if (this.gameBomAudioId) {
      this.gameBomAudioId.play();
    }
  }

  playGameTimerAudio = () => {
    if (this.gameTimerAudioId) {
      this.gameTimerAudioId.play();
    }
  }

  stopGameTimerAudio = () => {
    if (this.gameTimerAudioId) {
      this.gameTimerAudioId.pause();
    }
  }

  render() {
    const uiConfigs = this.props.uiConfigs;
    const isLTR = this.props.isLTR;
    const sizeFactor = uiConfigs.sizeFactor;
    const isDisabled = this.props.disabled;
    const rows = this.props.rows;
    const columns = this.props.columns;

    const cardSize = this.getCardSize();
    const cardSpacing = this.getCardSpacing();
    const gameViewWidth = Math.ceil((cardSize + cardSpacing) * columns + 1);
    const gameViewHeight = Math.ceil((cardSize + cardSpacing) * rows + 1);
    const gameBgStartMargin = uiConfigs.gameBgMarginStart * sizeFactor;
    const gameBgEndMargin = uiConfigs.gameBgMarginEnd * sizeFactor;
    const gameBgMarginTop = uiConfigs.gameBgMarginTop * sizeFactor;
    const gameBgMarginBottom = uiConfigs.gameBgMarginBottom * sizeFactor;

    const gameTimeLeft = ActivityHelper.getGameTimeText(this.props.gameTime - this.state.gameTimer);
    const showMovesCount = this.props.flipsNeeded && (this.props.flipsNeeded < 10000 || this.props.flipsNeeded - this.state.movesCount < 10000);
    let flipsCountText = null;
    if (showMovesCount) {
      flipsCountText = Math.max(0, this.props.flipsNeeded - this.state.movesCount);
    }

    const score = this.state.points || 0;
    const winValue = this.props.winValue;
    const progressViewWidth = cardSize * 2;
    const progressSpace = 4;
    let progressWidth = winValue > 0 ? progressViewWidth * Math.min(score/winValue, 1) - progressSpace : 0;
    if (progressWidth === -progressSpace) {
      progressWidth = 0;
    } else if (progressWidth < 1) {
      progressWidth = 1;
    } else if (progressWidth > progressViewWidth - 2 * progressSpace) {
      progressWidth = progressViewWidth - 2 * progressSpace;
    }

    let contentY = this.props.contentY + 36 * sizeFactor + gameBgMarginTop;
    if (flipsCountText || this.props.gameTime) {
      contentY += 48 * sizeFactor;
    }
    return (
      <View style={{alignItems: 'center'}}>
        <FocusHelperView
          onAppDidFocus={this.onDidFocus}
          onAppDidBlur={this.onDidBlur}
        />
        {!this.props.disableAudio ?
          <div>
            <GameAudio ref={(ref) => this.gamePlayAudioId = ref} source={this.props.gamePlayAudioUrl || GAME_CRUSH_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
            <GameAudio ref={(ref) => this.gameTimerAudioId = ref} source={GAME_TIMER_AUDIO} autoPlay={false} loop={true} hasUserInteraction={true} mute={this.props.mute} />
            <GameAudio ref={(ref) => this.gameBomAudioId = ref} source={GAME_BOMB_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
            <GameAudio ref={(ref) => this.gamePlayAudioIdNeutral = ref} source={GAME_NEUTRAL_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
            <GameAudio ref={(ref) => this.gamePlayAudioIdWin = ref} source={GAME_WIN_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
          </div>
          : null
        }
        {showMovesCount || this.props.gameTime ?
          <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center', padding: 8, paddingTop: 0, paddingBottom: 2 * sizeFactor, marginTop: -16 * sizeFactor}}>
            {showMovesCount ?
              <ImageBackground source={uiConfigs.tryCounterImage} resizeMode="fill" style={{height: 68 * sizeFactor, width: 130 * sizeFactor, flexDirection: 'row', alignItems: 'center', paddingTop: 18 * sizeFactor, marginLeft: 30, marginRight: 30}} >
                <AppText fontSizeN={uiConfigs.fontSize} style={{fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, flex: 1, marginLeft: (isLTR ? 46 : 4) * sizeFactor, marginRight: (isLTR ? 4 : 46) * sizeFactor, justifyContent: 'center'}}>
                  {flipsCountText}
                </AppText>
              </ImageBackground>
              : null
            }
            {this.props.gameTime ?
              <ImageBackground source={uiConfigs.timerImage} resizeMode="fill" style={{height: 68 * sizeFactor, width: 130 * sizeFactor, display: 'flex', flexDirection: 'row', alignItems: 'center', paddingTop: 18 * sizeFactor, marginLeft: 30, marginRight: 30}} >
                <AppText fontSizeN={uiConfigs.fontSize} style={{position: 'relative', fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, flex: 1, marginLeft: 48 * sizeFactor, marginRight: 4 * sizeFactor, display: 'flex', justifyContent: 'center'}}>
                  {gameTimeLeft}
                </AppText>
              </ImageBackground>
              : null
            }
          </View>
          : null
        }
        <ImageBackground source={uiConfigs.gameBgImage} resizeMode="fill" style={{display: 'flex',  flexDirection: 'row', alignItems: 'center', justifyContent: 'center', height: gameViewHeight + gameBgMarginTop + gameBgMarginBottom, width: gameViewWidth + gameBgStartMargin + gameBgEndMargin - (uiConfigs.gameBgWrapperMarginStart + uiConfigs.gameBgWrapperMarginEnd) * sizeFactor, marginLeft: uiConfigs.gameBgWrapperMarginStart * sizeFactor, marginRight: uiConfigs.gameBgWrapperMarginEnd * sizeFactor, paddingLeft: gameBgStartMargin, paddingRight: gameBgEndMargin, paddingTop: gameBgMarginTop, paddingBottom: gameBgMarginBottom, overflow: 'hidden', opacity: isDisabled ? 0.8 : 1}}>
          <View style={{position: 'absolute', top: 0, right: 0, left: 0, height: gameBgMarginTop + 2 * sizeFactor, display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}} >
            {/*<View style={{position: 'relative', width: progressViewWidth, height: 26 * sizeFactor, borderRadius: 13 * sizeFactor, borderWidth: 4 * sizeFactor, borderColor: 'rgb(124,193,73)', borderStyle: 'ridge', backgroundColor: 'rgb(69,8,37)', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden'}}>*/}
            {/*  <View style={{position: 'absolute', top: 2, bottom: 2, left: 2, width: winValue > 0 ? progressViewWidth/winValue*score - 4 : 0, borderRadius: 13 * sizeFactor, backgroundImage: 'linear-gradient(rgb(140,191,90), rgb(79,108,50))'}} />*/}
              <View style={{position: 'relative', width: progressViewWidth, height: 28 * sizeFactor, borderRadius: 13 * sizeFactor, borderWidth: 4 * sizeFactor, borderColor: 'rgb(133,191,80)', borderStyle: 'ridge', backgroundColor: 'rgb(69,8,37)', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden'}}>
                <View style={{position: 'absolute', top: 2, bottom: 2, left: 2, width: progressWidth, borderRadius: 13 * sizeFactor, backgroundImage: 'linear-gradient(rgb(253,244,83), rgb(237,116,64))'}} />
              <AppText fontSizeN={uiConfigs.fontSize} style={{position: 'relative', fontWeight: FontWeightMedium, color: uiConfigs.gameValue1TextColor, textAlign: 'center'}}>
                {score || '0'}
              </AppText>
            </View>
          </View>
          <Grid
            ref={(ref) => this.refGrid = ref}
            simulation={this.props.simulation}
            uiConfigs={this.props.uiConfigs}
            isLTR={this.props.isLTR}
            items={this.items}
            rows={this.props.rows}
            columns={this.props.columns}
            placeholderImageUrl={this.props.placeholderImageUrl}
            cardBgImage={this.props.uiConfigs.cardBgImage}
            size={cardSize}
            moleAppearTime={this.props.moleAppearTime}
            moleAppearExtraMaxTime={this.props.moleAppearExtraMaxTime}
            onChange={this.onChange}
            contentY={contentY}
            contentX={isLTR ? (this.props.contentWidth - gameViewWidth) / 2 : (this.props.contentWidth - gameViewWidth) / 2}
            onImageClicked={this.props.onImageClicked}
          />
          {this.state.isGameOver || isDisabled
            ? <View style={{position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, zIndex: 1}} />
            : null
          }
          {!this.props.simulation && (this.state.isWin || this.state.isLose) ?
            <View style={{position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, alignItems: 'center', justifyContent: 'center'}}>
              {/*<View>*/}
              {/*  <View style={{padding: 8, paddingLeft: 16, paddingRight: 16, marginBottom: 4, backgroundColor: AppUtils.colorWithAlpha(uiConfigs.messageBgColor, 0.9), borderRadius: 20}}>*/}
              {/*    <AppText fontSizeN={uiConfigs.fontSize} variant={'h6'} style={{color: uiConfigs.titleColor, fontWeight: FontWeightMedium, textAlign: 'center'}}>*/}
              {/*      {this.state.isWin ? locString('youWon') : locString('gameEndedNScore', {value: this.state.points})}*/}
              {/*    </AppText>*/}
              {/*  </View>*/}
                <CircularProgress size={uiConfigs.fontSize * 2} style={{color: uiConfigs.gameValueTextColor}}/>
              {/*</View>*/}
            </View>
            : null
          }
        </ImageBackground>
        {this.state.gameTimer === 0 && !this.props.hideAction ?
          <View style={{marginTop: - gameBgMarginBottom}}>
            <AppImageButtonEx
              ref={this.handleStartGameRef}
              disabled={this.props.disabled}
              imageStyle={{width: 220 * sizeFactor, height: 44 * sizeFactor}}
              titleStyle={{color: uiConfigs.actionTitleColor}}
              onClick={this.onStart}
              title={locString('startGame')}
              imageSource={uiConfigs.otherActionImage}/>
          </View>
          : null
        }
      </View>
    );
  }

  handleStartGameRef = (ref) => {
    this.refStartGame = ref;
  }

  onStart = () => {
    if (this.props.noActionMode) {
      this.props.onActionClickedInNoActionMode();
      return;
    }
    if (this.state.movesCount === 0) {
      if (this.props.onStart) {
        this.props.onStart();
      }
    }
    this.startGameTimer();
  };

  onChange = (isCounterUpdated, points) => {
    if (this.props.noActionMode) {
      this.props.onActionClickedInNoActionMode();
      return;
    }

    logDebug('onChange', {isCounterUpdated, points});
    // this.startGameTimer();
    const movesCount = isCounterUpdated ? this.state.movesCount + 1 : this.state.movesCount;
    const pointsEarned = Math.max(0, this.state.points + points);
    const isGameOver = this.processGameResult(pointsEarned, movesCount, this.state.gameTimer);
    if (isGameOver) {
      this.stopGameTimer();
    }
    this.setState({
      movesCount: movesCount,
      points: pointsEarned,
      isGameOver: isGameOver
    });
    if (points > 0) {
      this.playGamePlayAudio();
    } else if (points < 0) {
      this.playGameBomAudio();
    }
  };

  startGameTimer = () => {
    if (this.props.gameTime && !this.intervalHandler) {
      this.gameLastTime = new Date().getTime();
      this.intervalHandler = setInterval(() => {
        this.updateTimeElapsed();
      }, 1000);
      this.playGameTimerAudio();
      if (this.refGrid) {
        this.refGrid.start();
      }
      if (this.state.gameTimer === 0) {
        this.setState({
          gameTimer: 1,
        });
      }
    }
  }

  stopGameTimer = (updateElapsed = true) => {
    if (this.intervalHandler) {
      this.stopGameTimerAudio();
      clearInterval(this.intervalHandler);
      this.intervalHandler = null;
      if (updateElapsed) {
        this.updateTimeElapsed();
      }
    }
  }

  updateTimeElapsed = () => {
    let isGameOver = false;

    const currentTime = new Date().getTime();
    const timeDiff = currentTime - this.gameLastTime;
    this.gameLastTime = currentTime;
    const timeElapsed = Math.min(this.state.gameTimer + timeDiff, this.props.gameTime);
    const timeOver = timeElapsed >= this.props.gameTime;
    if (timeOver) {
      this.stopGameTimer();
      isGameOver = this.processGameResult(this.state.points, this.state.movesCount, timeElapsed);
    } else {
      if (this.refGrid) {
        this.refGrid.outFromMole();
      }
    }
    this.setState({
      gameTimer: timeElapsed,
      isGameOver: isGameOver
    });
  }

  isGameWin = (pointsEarned) => {
    return false;
  }

  isPlayEnded = (movesCount, gameTimer) => {
    if (this.props.flipsNeeded && this.props.flipsNeeded <= movesCount) {
      return true;
    }
    return this.props.gameTime && this.props.gameTime <= gameTimer;
  }

  processGameResult = (pointsEarned, movesCount, gameTimer) => {
    if (this.isGameWin(pointsEarned)) {
      setTimeout(() => {
        this.processGameEnd(true);
        this.setState({isWin: true, isLose: false});
      }, 400);
      return true;
    } else if (this.isPlayEnded(movesCount, gameTimer)) {
      setTimeout(() => {
        this.processGameEnd(false);
        this.setState({isWin: false, isLose: true});
      }, 200);
      return true;
    }
    return false;
  }

  processGameEnd = (isWin) => {
    if (!this.endGameProcessStartTime) {
      this.endGameProcessStartTime = new Date().getTime();

      // Vibration.vibrate(200);
      if (isWin) {
        if (this.gamePlayAudioIdWin) {
          this.gamePlayAudioIdWin.play();
        }
      } else {
        if (this.gamePlayAudioIdNeutral) {
          this.gamePlayAudioIdNeutral.play();
        }
      }

      // const endGameValue = JSON.stringify({isWin: isWin, value: this.state.points, timer: this.state.gameTimer});
      if (this.props.onEnd) {
        this.props.onEnd({isWin: isWin, value: this.state.points, timer: this.state.gameTimer});
      }
    }
  }

  getCardSize = () => {
    const uiConfigs = this.props.uiConfigs;
    const sizeFactor = uiConfigs.sizeFactor;
    const rows = this.props.rows;
    const columns = this.props.columns;

    const cardSpacing = this.getCardSpacing();
    const otherUiHeight = 100 * sizeFactor;
    const borderWidth = (uiConfigs.gameBgMarginStart + uiConfigs.gameBgMarginEnd) * sizeFactor;
    const borderHeight = (uiConfigs.gameBgMarginTop + uiConfigs.gameBgMarginBottom) * sizeFactor;
    const possibleWidth = (this.props.contentWidth - borderWidth - (columns + 1) * cardSpacing) / columns; // viewMargin, borderWidth, margin to each card
    const possibleHeight = (this.props.contentHeight - otherUiHeight - borderHeight - (rows + 1) * cardSpacing) / rows; // viewMargin, borderWidth, margin to each card
    const possibleSize = Math.min(possibleWidth, possibleHeight);
    const cardSize = Math.floor(Math.min(200, possibleSize));
    logDebug('CardSize', cardSize);
    return cardSize;
  }

  getCardSpacing = () => {
    return 4;
  }
}

class Grid extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      tileDataSource: this.initializeDataSource(this.props.items),
      play: false
    };
  }

  render() {
    return (
      <View style={{
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <View
          style={{
            width: this.props.size * this.props.columns,
            height: this.props.size * this.props.rows,
            flexDirection: this.props.isLTR ? 'row' : 'row-reverse',
            flexWrap: 'wrap'
          }}>
          {this.renderTiles(this.state.tileDataSource)}
        </View>
      </View>
    );
  }

  renderTiles = (tileData) => {
    let tiles = [];
    tileData.forEach((row, y) => {
      row.forEach((column, x) => {
        tiles.push(
          <Tile
            onClick={() => {
              this.onColumnClick(column);
            }}
            uiConfigs={this.props.uiConfigs}
            size={this.props.size}
            location={column.location}
            locationX={column.locationX}
            locationY={column.locationY}
            scale={column.scale}
            key={column.key}
            img={this.state.play ? column.data.imageUrl : this.props.placeholderImageUrl}
            cardBgImage={this.props.cardBgImage}
          />,
        );
      });
    });
    return tiles;
  }

  onColumnClick = (column) => {
    if (column.touchEnabled) {
      column.touchEnabled = false;
      this.props.onChange(true, column.data.value1);
      // column.scale.update({
      //   config: {
      //     duration: 50,
      //   },
      //   duration: 50,
      //   to: 0,
      // }).start()
    }
  }

  start = () => {
    this.state.tileDataSource.forEach((row, y) => {
      row.forEach((elem, x) => {
        elem.scale.set(0);
      });
    });
    this.setState({play: true});
  }

  reset = (items) => {
    this.setState({tileDataSource: this.initializeDataSource(items), play: false});
  }

  outFromMole = () => {
    const outCount = this.getRandomInt(4, [0]);
    if (outCount > 0) {
      const keys = [];
      for (let i = 0; i < outCount; i++) {
        const key = this.getRandomInt(this.props.rows * this.props.columns, keys);
        keys.push(key);
        const {sx, sy} = this.getXY(key);
        const durationToOut = 300;

        this.state.tileDataSource[sy][sx].scale.update({
          config: {
            // easing: easing,
            duration: durationToOut,
          },
          duration: durationToOut,
          // from: 0,
          to: 1,
        }).start().then(() => {
          const delay = this.props.moleAppearTime + this.getRandomInt(this.props.moleAppearExtraMaxTime);
          const durationToIn = 300;
          this.state.tileDataSource[sy][sx].scale.update({
            config: {
              // easing: easing,
              duration: durationToIn,
              delay: delay
            },
            duration: durationToIn,
            // from: 1,
            to: 0,
            delay: delay
          }).start();
          setTimeout(() => {
            this.state.tileDataSource[sy][sx].touchEnabled = false;
          }, delay + durationToIn/2);
        });

        // Animated.timing(this.state.tileDataSource[sy][sx].scale, {
        //   toValue: 1,
        //   duration: durationToOut,
        // }).start(() => {
        //   const delay = this.props.moleAppearTime + this.getRandomInt(this.props.moleAppearExtraMaxTime);
        //   const durationToIn = 250;
        //   Animated.timing(this.state.tileDataSource[sy][sx].scale, {
        //     toValue: 0,
        //     duration: durationToIn,
        //     delay: delay
        //   }).start();
        //   setTimeout(() => {
        //     this.state.tileDataSource[sy][sx].touchEnabled = false;
        //   }, delay + durationToIn/2);
        // });
        setTimeout(() => {
          const column = this.state.tileDataSource[sy][sx];
          column.touchEnabled = true;
          if (this.props.simulation && Math.random() > (column.data.value1 > 0 ? 0.3 : 0.9)) {
            setTimeout(() => {
              this.onColumnClick(column);
            }, 70 + (20*i));
          }
        }, durationToOut/2)
      }
    }
  }

  initializeDataSource = (items) => {
    // Grid that contains the keys that will be assigned to each tile via map
    let keys = [];
    for (let y = 0; y < this.props.rows; y++) {
      let rows = [];
      for (let x = 0; x < this.props.columns; x++) {
        rows.push(y * this.props.columns + x);
      }
      keys.push(rows);
    }
    // let keys = [
    //     [0, 1, 2, 3, 4],
    //     [5, 6, 7, 8, 9],
    //     [10, 11, 12, 13, 14],
    //     [15, 16, 17, 18, 19],
    //     [20, 21, 22, 23, 24],
    // ];

    return keys.map((row, y) => {
      return row.map((key, x) => {
        let int = this.getRandomInt(items.length);
        let randomBeanObj = items[int];
        return new TileData(randomBeanObj, key);
      });
    });
  }

  getXY = (key) => {
    const sy = parseInt(key / this.props.columns);
    const sx = key % this.props.columns;
    return {sx, sy};
  }

  getRandomInt = (max, excepts = undefined) => {
    const random = Math.floor(Math.random() * Math.floor(max));
    if (excepts && excepts.includes(random)) {
      return this.getRandomInt(max, excepts);
    }
    return random;
  };
}

class TileData {

  constructor(data, key) {
    this.key = key;
    this.data = data;
    this.markedAsMatch = false;
    this.location = new SpringValue(0);
    this.locationX = new SpringValue(0);
    this.locationY = new SpringValue(0);
    this.touchEnabled = false;
    this.scale = new SpringValue(1);
  }
}

class Tile extends React.PureComponent {

  render() {
    const size = this.props.size;
    const padding = 8 * this.props.uiConfigs.sizeFactor;
    const imageSize = size - 2 * padding;
    return (
      <ImageBackground source={this.props.cardBgImage} resizeMode="fill" style={{width: size, height: size, alignItems: 'center', justifyContent: 'center', padding: padding}}>
        <TouchableOpacityWOFeedback onClick={this.props.onClick}>
          <animated.div
            style={{
              width: imageSize,
              height: imageSize,
              alignItems: 'center',
              justifyContent: 'center',
              opacity: this.props.scale,
              // transform: [{scale: this.props.scale}],
            }}>
            {this.props.img ?
              <AppImage
                style={{width: imageSize, height: imageSize, borderRadius: RadiusView}}
                imageUrl={this.props.img}
              />
              : null
              // <Image
              //   style={{width: imageSize, height: imageSize, borderRadius: RadiusView}}
              //   source={require('src/images/img_logo.png')}
              // />
            }
          </animated.div>
        </TouchableOpacityWOFeedback>
      </ImageBackground>
    );
  }
}
